import * as fromTypes from "./types";

export const setGeolocation = (payload) => ({
	type: fromTypes.SET_GEOLOCATION,
	payload,
});
